import { useEffect, useState } from 'react';
import { VeralliaConveyor } from './VeralliaConveyor';
import { VeralliaDefaultBlock } from './VeralliaDefaultBlock';
import { DEFECT_TYPES_NAMES, VERALLIA_CONVEYORS, isSecondaryDefect } from '../../../services/live-interface/verallia-interface-service';

const DEFAULT_DISPLAY_DURATION_MS = 5000;

export const VeralliaLine = ({ lineId, pallets = [] }) => {
  const [currentDefaultIndex, setCurrentDefaultIndex] = useState(0);

  const locations = VERALLIA_CONVEYORS[lineId]?.locations ?? [];

  const visiblePallets = pallets.filter((pallet) => {
    const locationIndex = Number(pallet.progress);
    return Number.isInteger(locationIndex) && locationIndex >= 0 && locationIndex < locations.length && locations[locationIndex] !== -1;
  });

  const displayedPallets = visiblePallets.map((pallet) => {
    const palletDefaults = pallet.defaults ?? [];
    const importantDefaults = palletDefaults.filter((defaultData) => !isSecondaryDefect(defaultData.type));
    return { ...pallet, defaults: importantDefaults.length > 0 ? importantDefaults : palletDefaults };
  });

  const defaults = displayedPallets.flatMap((pallet) => pallet.defaults.map((defaultData) => ({ ...defaultData, palletId: pallet.id })));
  const defaultsSignature = defaults.map(({ client_id, time, face, type, palletId }) => `${palletId}-${client_id}-${time}-${face}-${type}`).join('|');
  const displayedDefaultIndex = currentDefaultIndex < defaults.length ? currentDefaultIndex : 0;
  const activeDefault = defaults[displayedDefaultIndex] ?? null;
  const statusColor = activeDefault === null ? 'green' : isSecondaryDefect(activeDefault.type) ? 'amber' : 'red';
  const statusText = activeDefault === null
    ? 'Ningún defecto'
    : `${activeDefault.palletId} - ${DEFECT_TYPES_NAMES[activeDefault.type] ?? 'DESCONOCIDO'}`;

  useEffect(() => {
    setCurrentDefaultIndex(0);
  }, [defaultsSignature]);

  useEffect(() => {
    if (defaults.length <= 1) return undefined;

    const intervalId = window.setInterval(() => {
      setCurrentDefaultIndex((currentIndex) => (currentIndex + 1) % defaults.length);
    }, DEFAULT_DISPLAY_DURATION_MS);

    return () => window.clearInterval(intervalId);
  }, [defaults.length, defaultsSignature]);

  return (
    <div className={`flex h-full w-full flex-col overflow-hidden rounded-lg border-x-[6px] border-b-[6px] bg-perception-black-500 ${statusColor === 'red' ? 'border-red-500' : statusColor === 'amber' ? 'border-amber-500' : 'border-green-500'}`}>
      <div className={`shrink-0 break-words p-2 text-[2.75rem] font-extrabold leading-tight ${statusColor === 'red' ? 'bg-red-500 text-white' : statusColor === 'amber' ? 'bg-amber-500 text-black' : 'bg-green-500 text-white'}`}>
        #{lineId} - {statusText}
      </div>

      <div className="flex min-h-0 flex-1">
        <div className="relative z-10 h-full w-1/4 min-w-0 overflow-visible">
          <VeralliaConveyor lineId={lineId} pallets={visiblePallets} activeDefault={activeDefault} />
        </div>

        <div className="h-full min-h-0 w-3/4 min-w-0">
          <VeralliaDefaultBlock defaults={defaults} currentDefaultIndex={displayedDefaultIndex} defaultsSignature={defaultsSignature} displayDurationMs={DEFAULT_DISPLAY_DURATION_MS} />
        </div>
      </div>
    </div>
  );
};